// src/pages/SettingsPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';

function SettingsPage() {
  const { t } = useTranslation();
  
  return (
    <main className="container py-4" role="main">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <h1 className="mb-4">{t('settings.title')}</h1>
          <div className="card">
            <div className="card-body">
              <form>
                <fieldset>
                  <legend className="h5 mb-3">{t('settings.quizPreferences')}</legend>
                  <div className="mb-3">
                    <div className="form-check form-switch">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="instantFeedback"
                        role="switch"
                        aria-checked="false"
                      />
                      <label className="form-check-label" htmlFor="instantFeedback">
                        {t('settings.showInstantFeedback')}
                      </label>
                    </div>
                  </div>
                </fieldset>

                <fieldset className="mt-4">
                  <legend className="h5 mb-3">{t('settings.accessibility')}</legend>
                  <div className="mb-3">
                    <div className="form-check form-switch">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="highContrast"
                        role="switch"
                        aria-checked="false"
                      />
                      <label className="form-check-label" htmlFor="highContrast">
                        {t('settings.highContrast')}
                      </label>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="fontSize" className="form-label">{t('settings.fontSize')}</label>
                    <select 
                      className="form-select" 
                      id="fontSize"
                      aria-label={t('settings.selectFontSize')}
                    >
                      <option value="normal">{t('settings.fontSizes.normal')}</option>
                      <option value="large">{t('settings.fontSizes.large')}</option>
                      <option value="xlarge">{t('settings.fontSizes.xlarge')}</option>
                    </select>
                  </div>
                </fieldset>
                
                <div className="mt-4">
                  <button 
                    type="submit" 
                    className="btn btn-primary"
                    aria-label={t('settings.saveChanges')}
                  >
                    {t('settings.saveChanges')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default SettingsPage;
